module.exports = __webpack_public_path__ + "../resources/graphql/schema.all.min-bceb7e9db1d7169983b4eed839783dbc.graphql";